import { Box, Container } from "@mui/material";
import React, { useEffect } from "react";
import { StepperWizard } from "../../../../core/components/wizard/StepperWizard";
import WizardStep from "../../../../core/components/wizard/WizardStep";
import { AddStory } from "./steps/AddStory";
import { useStoryContext } from "../story.context";
import { StoryParts } from "./steps/StoryParts";

export const CreateStoryWizard: React.FC = (): JSX.Element => {
    const { activeStep, completedSteps, changeStep, clearProvider, story } = useStoryContext();

    // Clear the context only when adding a new story (not when editing)
    // If story.id exists, we're in edit mode and should preserve the context
    useEffect(() => {
        if (!story || !story.id) {
            clearProvider();
        }
    }, []);

    return (
        <Box p={4}>
            <Container maxWidth={"md"}>
                <StepperWizard activeStep={activeStep} goToStep={changeStep} orientation="horizontal">
                    <WizardStep identifier={0} heading="Story Details" completed={completedSteps[0]}>
                        <AddStory />
                    </WizardStep>
                    <WizardStep identifier={1} heading="Story Parts" completed={completedSteps[1]}>
                        <StoryParts />
                    </WizardStep>
                </StepperWizard>
            </Container>
        </Box>
    );
};
